"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _enviro = _interopRequireDefault(require("enviro"));

var BaseReporter = /*#__PURE__*/function () {
  function BaseReporter() {
    (0, _classCallCheck2.default)(this, BaseReporter);
    this.debug = _enviro.default.debug('react-rhumb') === 'true';
    this.libName = "react-rhumb";
  }

  (0, _createClass2.default)(BaseReporter, [{
    key: "performanceMark",
    value: function performanceMark(name) {
      if (typeof performance.mark === 'function') {
        performance.mark(name);
      }
    }
  }, {
    key: "performanceEntries",
    value: function performanceEntries() {
      if (typeof performance.getEntries === 'function') {
        return performance.getEntries() || [];
      }

      return [];
    }
  }, {
    key: "toDuration",
    value: function toDuration(checks, timestamp, markers) {
      var longest = Math.max.apply(Math, (0, _toConsumableArray2.default)(markers.filter(function (marker) {
        return Object.prototype.hasOwnProperty.call(checks, marker);
      }).map(function (marker) {
        return checks[marker].timestamp;
      })));
      return Math.max(0, longest - timestamp);
    }
  }, {
    key: "setCustomAttribute",
    value: function setCustomAttribute(attributeName, attributeValue) {
      if (window.newrelic) {
        window.newrelic.setCustomAttribute(attributeName, attributeValue);
      }
    }
  }, {
    key: "addPageAction",
    value: function addPageAction(actionName, actionPayload) {
      if (window.newrelic) {
        window.newrelic.addPageAction(actionName, actionPayload);
      }
    }
  }, {
    key: "report",
    value: function report(__action) {
      throw new Error('Reporters must define a custom report() function');
    }
  }]);
  return BaseReporter;
}();

exports.default = BaseReporter;
module.exports = exports.default;